import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import i18n from '@/locales';

import Amplify from 'aws-amplify';
import aws_exports from './aws-exports';

import directivas from '@/library/directivas';
import filters from '@/library/filters';

import {getEnvVar} from '@/library/utils/env-vars';

Amplify.configure(aws_exports);

//Vue.config.productionTip = false;
// Importar config aunque no se use aquí, para verificar que todaa la configuración
// existe en variables de entorno. NO REMOVER ESTE IMPORT.
import * as config from '@/config';

Amplify.configure({
	Auth: {
		region: getEnvVar('awsRegion'),
		// When token become expired:
		// https://aws-amplify.github.io/docs/js/authentication#token-refresh
		// https://github.com/aws-amplify/amplify-js/issues/2529
		// https://github.com/aws-amplify/amplify-js/pull/665
		refreshHandlers: {
			'developer': config.refreshHandlerAwait
		},
	}
});

const vue = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');